var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationBalanceSheetLight = function SvgIllustrationBalanceSheetLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 194,
    fill: "none",
    viewBox: "0 0 248 194"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 339.335,
    height: 288.235,
    x: -47.668,
    y: -47.618
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(28px)",
      clipPath: "url(#IllustrationBalanceSheetLight_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 56,
    filter: "url(#IllustrationBalanceSheetLight_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 165,
    x: 16.968,
    y: 8.382,
    fill: "url(#IllustrationBalanceSheetLight_svg__c)",
    rx: 1.302,
    shapeRendering: "crispEdges",
    transform: "rotate(3 16.968 8.382)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 225.21,
    height: 170.21,
    x: 11.395,
    y: 11.395
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.3px)",
      clipPath: "url(#IllustrationBalanceSheetLight_svg__d)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.605
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 164,
    x: 14.5,
    y: 14.5,
    fill: "url(#IllustrationBalanceSheetLight_svg__e)",
    fillOpacity: 0.56,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 164,
    x: 14.5,
    y: 14.5,
    stroke: "url(#IllustrationBalanceSheetLight_svg__f)",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    x: 32,
    y: 32,
    fill: "#C8D3DF",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 3,
    x: 32,
    y: 38,
    fill: "#C8D3DF",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 36,
    y: 57,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 137,
    y: 57,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 182,
    y: 57,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 64.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 36,
    y: 69,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 200,
    y: 69,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 74.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 2,
    x: 36,
    y: 79,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 158,
    y: 79,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 194,
    y: 79,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 84.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 36,
    y: 89,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 143,
    y: 89,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 94.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    x: 36,
    y: 99,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 137,
    y: 99,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 104.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    x: 36,
    y: 109,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 149,
    y: 109,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 188,
    y: 109,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 114.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 36,
    y: 119,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 194,
    y: 119,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 124.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 2,
    x: 36,
    y: 129,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 149,
    y: 129,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8D3DF",
    strokeWidth: 0.5,
    d: "M32 134.75h184"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    x: 36,
    y: 139,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 155,
    y: 139,
    fill: "#C8D3DF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 188,
    y: 139,
    fill: "#C8D3DF",
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IllustrationBalanceSheetLight_svg__c",
    x1: 21.471,
    x2: 113.127,
    y1: 11.646,
    y2: 225.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F8FF",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F8FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IllustrationBalanceSheetLight_svg__e",
    x1: 16.773,
    x2: 114.936,
    y1: 14.909,
    y2: 232.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IllustrationBalanceSheetLight_svg__f",
    x1: 209.137,
    x2: 159.963,
    y1: 179,
    y2: 55.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FAFC3",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FAFC3",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IllustrationBalanceSheetLight_svg__a",
    transform: "translate(47.668 47.618)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 165,
    x: 16.968,
    y: 8.382,
    rx: 1.302,
    transform: "rotate(3 16.968 8.382)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IllustrationBalanceSheetLight_svg__d",
    transform: "translate(-11.395 -11.395)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 164,
    x: 14.5,
    y: 14.5,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "IllustrationBalanceSheetLight_svg__b",
    width: 339.335,
    height: 288.235,
    x: -47.668,
    y: -47.618,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 8,
    result: "effect1_dropShadow_351_30193"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_351_30193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_351_30193",
    result: "shape"
  })))));
};
export default SvgIllustrationBalanceSheetLight;